import React from "react";
import Progress from "antd/lib/progress"
import 'antd/lib/progress/style/index.css';
import './patient-tv-report.scss';


function SeCircle({ se, id }) {
    const value = Math.round(se);

    return (
        <>
            <div className="se-circle" id={"se-circle-" + id} >
                <Progress
                    type="circle"
                    percent={value}
                />
            </div>
        </>
    )
}

export default SeCircle;
